<template>
  <div class="container" :class="showNewUi && 'new-account'">
    <h3>{{ $t("message.yourDetails") }}</h3>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="Name"
          >{{ $t("message.name") }}
          <span v-if="showNewUi" style="color: #ff0000">*</span></label
        >

        <input
          v-validate="'required|min:2'"
          id="Name"
          v-model="fullName"
          name="name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("name") | inputNameLocale("name") }}
        </div>
      </div>
      <div class="form-group col-md-6">
        <label class="required" for="PhoneNumber">{{
          $t("message.mobile")
        }}</label>
        <input
          v-validate="{
            required: true,
            min: 8,
            regex: this.getRegex(),
          }"
          id="PhoneNumber"
          disabled
          v-model="editModel.Phone"
          name="phoneNumber"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="EmailAddress"
          >{{ $t("message.emailAddress") }}
          <span v-if="showNewUi" style="color: #ff0000">*</span></label
        >
        <ValidationProvider
          name="Email Address"
          mode="lazy"
          rules="email"
          v-slot="{ errors }"
        >
          <input
            id="EmailAddress"
            v-model="editModel.Email"
            :disabled="emailDisabled"
            name="Email Address"
            type="text"
            class="form-control"
            :aria-invalid="errors.length > 0 ? true : false"
          />
          <div class="invalid-feedback">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { auth } from "../../server";

export default {
  name: "MyDetail",
  props: {
    editModel: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["selectedCompany", "viewConfig"]),
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },

    fullName: {
      get() {
        if (!this.editModel.LastName.length) {
          return this.editModel.FirstName;
        }
        return this.editModel.FirstName + " " + this.editModel.LastName;
      },
      set(val) {
        if (!val) return;
        const [firstName, ...lastName] = val.split(" ").filter(Boolean);
        this.editModel.FirstName = firstName;
        this.editModel.LastName = lastName.join(" ");
      },
    },
    emailDisabled() {
      if (auth.currentUser && auth.currentUser.email) {
        return true;
      }
      return false;
    },
  },
  methods: {
    validate() {
      return this.$validator.validateAll();
    },
    getMax() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" || country == "Australia" ? 10 : 15;
    },
    getRegex() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" || country == "Australia" ? /04\d{8}/ : /\d/;
    },
  },
};
</script>
